// ***** Sevices *****
import { getHostsByOrganizationId } from '@services/device/host'
// ***** Dependencies *****
import logger from '@functions/logger'
import { RootState } from '@redux/store'
//***** Hooks *****
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
// ***** Components *****
import EmptyHost from '@modules/devices/components/host/EmptyHost'
import Table from '@components/table/table'
import DeleteModal from '@modules/practitioner/profile/public/Education/DeleteModal';
// ***** Interfaces, Types and imports *****
import Host from '@interfaces/device/host'
// import { InfoTableButtonsI } from '@interfaces/tables/tables'
import InfoTableContentI, { InfoTableButtonsI } from '@interfaces/tables/tables'
import DetailedTable from '@components/detailed-table/detailed-table'
import HostItem from './host-item/HostItem'
import { useNavigate } from 'react-router-dom';

type HostListProps = {
  name: string
  hosts: Array<Host>
  changeComponent: (componentName: string) => void
  setBullets: () => void
  deleteHost: (id: string) => void
  setOrganizationHostId: (organizationHostId: string) => void
  setHostEdit: (host: Host) => void
  setHosts: (hosts: Host[]) => void
  setHostToDevice: (host: Host) => void
}



const HostList = ({ hosts, changeComponent, setBullets, deleteHost, setOrganizationHostId, setHostEdit, setHosts, setHostToDevice }: HostListProps) => {

  const { t } = useTranslation(['myDevices'])
  const history = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [idToBeDeleted, setIdToBeDeleted] = useState<string>('')
  const defaultOrganization = useSelector((state: RootState) => state.organizations)
  const [hostShowSelected, setHostShowSelected] = useState<Host | undefined>();

  const sorted = useCallback((hostList: Host[]) => {
    const list = [...hostList]
    setHosts(list.sort((a, b) => b.deviceHostId < a.deviceHostId ? -1 : 0))
  }, [setHosts])

  const getHosts = useCallback(async (organizationId: number) => {
    try {
      const orgHosts: Host[] = await getHostsByOrganizationId(organizationId)
      sorted(orgHosts)
      //setHosts(orgHosts)
    } catch (error) {
      logger.log(error)
    }
  }, [sorted])

  useEffect(() => {
    getHosts(defaultOrganization.organizationId)
  }, [getHosts, defaultOrganization])

  useEffect(() => {
    setBullets()
  }, [setBullets])

  const showDevices = (organizationHostId: string, hostToDevice: Host) => {
    setHostToDevice(hostToDevice)
    changeComponent("devicesScreen")
    setOrganizationHostId(organizationHostId)
  }

  const delHost = async () => {
    setOpenModal(false);
    setHostShowSelected(undefined)
    deleteHost(idToBeDeleted)
  }

  const setHostToEdit = (host: Host) => {
    setHostEdit(host);
  }

  const deleteHosTModal = (id: string) => {
    setIdToBeDeleted(id)
    setOpenModal(true);
  }

  /**
   * Set the hostShowSelected and change the view to DetailedTable component
  */
  const changeHostShowSelected = (host: Host) => {
    setHostShowSelected(host)
  }
  /**
   * Set the hostShowSelected to undefined and change the view to Table view
  */
  const cleanHostShowSelected = () => {
    setHostShowSelected(undefined)
  }

  /**
   * Function to get the values to render in DetailedTable component
  */
  const getContent = () => {
    if (!hostShowSelected) return;
    const content: InfoTableContentI[] = [
      {
        label: t('host.table.identification'),
        value: hostShowSelected.identificationHost
      },
      {
        label: t('host.table.protocol'),
        value: ` ${hostShowSelected.protocol}`
      },
      {
        label: t('host.table.host'),
        value: ` ${hostShowSelected.host}`
      },
      {
        label: t('host.table.port'),
        value: ` ${hostShowSelected.port}`
      },
      {
        label: t('host.table.context'),
        value: ` ${hostShowSelected.context}`
      }
    ]
    return content
  };

  /**
   * Function to get the buttons to render in DetailedTable component
  */
  const getButtons = () => {
    if (!hostShowSelected) return undefined;
    const buttons: InfoTableButtonsI[] = [
      {
        buttontext: t('buttons.editHost'),
        action: () => setHostToEdit(hostShowSelected),
        outlined: true
      },
      {
        buttontext: t('buttons.showDevices'),
        action: () => showDevices(hostShowSelected.deviceHostId, hostShowSelected)
      },
      {
        buttontext: t('buttons.deleteHost'),
        action: () => deleteHosTModal(hostShowSelected.deviceHostId),
        outlined: true
      },
    ]
    return buttons
  };

  return (
    <div className="Services__Card">
      <DeleteModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        onDeleteRow={() => delHost()}
      />
      {hostShowSelected ?
        <DetailedTable
          title={`ID ${hostShowSelected.deviceHostId}`}
          goBack={() => cleanHostShowSelected()}
          content={getContent()}
          buttons={getButtons()}
        />
        :
        <div>
          {
            !hosts.length
              ? (<EmptyHost name="emptyHost" changeComponent={(componentName: string) => changeComponent(componentName)} />)
              :

              <div className="Devices">
                <div className="title-btn">
                    <div className="HorizontalFlex__Gap items__center">
                        <i className="far fa-arrow-left" onClick={() => history(-1)}/>
                        <h2 className="Title5">{t('hostSubtitle')}</h2>
                    </div>
                    <button className="btn-primary__responsive" onClick={() => changeComponent("hostForm")}>
                        <i className="far fa-plus"/>
                        <p className="Body2"  >{t('host.addTitle')} </p>
                    </button> 
                </div>

                <Table type={1}>
                  <>
                    {
                      hosts.map(host => (
                        <HostItem
                            key={host.identificationHost}
                            host={host}
                            setHostToEdit={() => setHostToEdit(host)}
                            deleteHosTModal={() => deleteHosTModal(host.deviceHostId)}
                            showDevices={() => showDevices(host.deviceHostId, host)}
                            changeHostShowSelected={() => changeHostShowSelected(host)}
                        />
                      ))
                    }
                  </>
                </Table>
              </div>
          }
        </div>}
    </div>
  )
}

export default HostList
